module.exports = __webpack_public_path__ + "img/img_v@2x.02acfc19.png";